module.exports = __webpack_public_path__ + "static/img/how-much.f835362.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/how-much.png
// module id = IRsU
// module chunks = 6